import { RequestBuilder, authorizedPipe } from 'services/net'
import { CONTENT_SERVICE_URL } from 'config'
import { RangeFilter, LegacyVideo } from 'interfaces'
import { StockContentProvider } from 'interfaces/Content/StockContentProvider'
import { SortBy, STOCK_CONTENT_PROVIDER_PARAMS_MAP } from '../util'

export const ENDPOINT_VIDEOS_EXTRACT = `${CONTENT_SERVICE_URL}/feeds/:sourceId/content/videos`
export const ENDPOINT_VIDEOS_FOLDER_EXTRACT = `${CONTENT_SERVICE_URL}/streams/:folderId/content/videos`

export const V1 = Object.freeze({
  getVideos: function () {
    return function (
      sourceId: string,
      page: number,
      rangeFilter: RangeFilter,
      sortBy: SortBy,
      stockSource?: StockContentProvider
    ) {
      const builder = new RequestBuilder(ENDPOINT_VIDEOS_EXTRACT).asGet().expectJSON().withoutCredentials()
      if (stockSource) {
        builder.param('stock_filter', STOCK_CONTENT_PROVIDER_PARAMS_MAP.videos[stockSource])
      }

      return authorizedPipe<{ content: LegacyVideo[] }>(
        builder
          .partial(':sourceId', sourceId)
          .param('page', page.toString())
          .param('range_filter', rangeFilter)
          .param('sort_by', sortBy)
          .build()
      )
    }
  }(),
  getVideosFromFolder: function () {
    const builder = new RequestBuilder(ENDPOINT_VIDEOS_FOLDER_EXTRACT).asGet().expectJSON().withoutCredentials()

    return function (folderId: string, page: number, rangeFilter: RangeFilter, sortBy: SortBy) {
      return authorizedPipe<{ content: LegacyVideo[] }>(
        builder
          .partial(':folderId', folderId)
          .param('page', page.toString())
          .param('range_filter', rangeFilter)
          .param('sort_by', sortBy)
          .build()
      )
    }
  }()
})
